import AppLayout from '@cloudscape-design/components/app-layout';
import I18nProvider from '@cloudscape-design/components/i18n';
import enMessages from '@cloudscape-design/components/i18n/messages/all.en';
import { useAppSelector, useAppDispatch } from 'src/store/hooks';
import { setRegion } from 'src/store/slices/env/envSlice';
import { BeaconHeader } from './header/BeaconHeader';
import { AppRoutes } from './Routes';
import { GlobalNotifications } from 'src/components/common/GlobalNotifications';

export const App = () => {
  const selectedRegion = useAppSelector(state => state.env.region);
  const dispatch = useAppDispatch();

  return (
    <I18nProvider locale="en" messages={[enMessages]}>
      <BeaconHeader
        selectedRegion={selectedRegion}
        onRegionChange={(id) => dispatch(setRegion(id))}
      />
      <AppLayout
        content={<AppRoutes />}
        notifications={<GlobalNotifications />}
        navigationHide
        toolsHide
        headerSelector="#beacon-header"
        maxContentWidth={Number.MAX_VALUE}
      />
    </I18nProvider>
  );
};
